import React from 'react';
import { Navigate } from 'react-router-dom';

const QuickSetupRouteGuard = ({ children }) => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  const userType = currentUser?.user?.userType;
  const quickSetup = currentUser?.user?.quickSetup;

  // If user is client and quickSetup is true, redirect to dashboard
  if (userType === 'client' && quickSetup === true) {
    return <Navigate to="/dashboard" replace={true} />;
  }

  return children;
};

export default QuickSetupRouteGuard;

